import React, { PropTypes } from 'react';

const ReferralFormField = (props) => {
  const { input, label, type, isRequired, meta: { touched, error } }  = props;
  const hasError = touched && error;

  return (
    <div>
      <label htmlFor={`${input.name}`}>
        {label}
        {isRequired && <span className="required"> *</span>}
      </label>
      <input
        {...input}
        id={`${input.name}`}
        className={hasError ? 'is-invalid-input' : ''}
        type={type}
      />
      {hasError && <span className="form-error is-visible">{error}</span>}
    </div>
  );
};

ReferralFormField.propTypes = {
  input: PropTypes.object,
  label: PropTypes.string,
  type: PropTypes.string,
  isRequired: PropTypes.bool,
  meta: PropTypes.object
};

export default ReferralFormField;




/** WEBPACK FOOTER **
 ** ./src/members/Main/Referral/ReferralForm/ReferralFormField/index.js
 **/